/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export { NzTabAddButtonComponent as ɵNzTabAddButtonComponent } from './tab-add-button.component';
export { NzTabsInkBarDirective as ɵNzTabsInkBarDirective } from './tabs-ink-bar.directive';
export { NzTabNavBarComponent as ɵNzTabNavBarComponent } from './tab-nav-bar.component';
export { NzTabNavItemDirective as ɵNzTabNavItemDirective } from './tab-nav-item.directive';
export { NzTabBodyComponent as ɵNzTabBodyComponent } from './tab-body.component';
export { NzTabNavOperationComponent as ɵNzTabNavOperationComponent } from './tab-nav-operation.component';
export { NzTabScrollListDirective as ɵNzTabScrollListDirective } from './tab-scroll-list.directive';
export { NzTabCloseButtonComponent as ɵNzTabCloseButtonComponent } from './tab-close-button.component';
export * from './tab.component';
export * from './tab.directive';
export * from './tab-link.directive';
export * from './tabs.module';
export * from './tabset.component';
export * from './interfaces';
